import { memo, useRef, useContext } from "react";
import MarkdownIt from "markdown-it";

import { contentBlockPlugin } from "@mywheels/common/util";

import { renderRules } from "./renderRules";
import { AstRenderer } from "./renderer";

import {
  //cleanupTokens,
  tokensToAST,
  groupTextTokens,
} from "./util";
import { ContentBlocksContext } from "./blocks";

const markdownIt = new MarkdownIt({
  html: false,
  breaks: true,
  xhtmlOut: true,
  linkify: true,
}).use(contentBlockPlugin);

type Props = {
  source: string; // markdown
  inline?: boolean;
  className?: string;
  contentBlocks?: boolean;
};

export const Markdown = memo(
  ({ source, className, inline = false, contentBlocks = true }: Props) => {
    const blocks = useContext(ContentBlocksContext);

    const renderer = useRef<AstRenderer>();
    if (!renderer.current) {
      renderer.current = new AstRenderer(
        renderRules,
        contentBlocks ? blocks : {}
      );
    }

    try {
      let tokens = inline
        ? markdownIt.parseInline(source, {})
        : markdownIt.parse(source, {});

      // tokens = cleanupTokens(tokens);
      tokens = groupTextTokens(tokens);
      const astTree = tokensToAST(tokens as never);

      return renderer.current.render(astTree, { inline, className });
    } catch {
      return null;
    }
  }
);
